import api from "../../api";

export default {
  async updateAllocatedTime(_, data) {
    try {
      await api.post("/projects/update-left-hours", data);
    } catch (error) {
      console.error("Error en la solicitud:", error);
      throw error;
    }
  },
  async addProject({ commit }, data) {
    try {
      console.log("[addProject] payload:", data);
      const response = await api.post(
        "new-kambuchi/projects/add-project",
        data
      );
      console.log("[addProject] response:", response);

      if (response.ok) {
        return response;
      } else {
        commit("setSnackbar", {
          text: response.error
            ? `Error while adding project: ${response.error}`
            : "Unexpected error while adding project",
          enabled: true,
        });
        return response;
      }
    } catch (error) {
      console.error("Error in addProject action:", error);
      throw error;
    }
  },
  async fetchProject({ commit }, { id_project, user_type, id_user }) {
    try {
      const response = await api.get("/new-kambuchi/projects/get-project", {
        id: id_project,
        user_type: user_type,
        id_user: id_user,
      });
      commit("setDetails", response.project);
      return response;
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  },
  async addProjectResources({ commit }, data) {
    try {
      const response = await api.post("/new-kambuchi/projects/add-users", data);

      if (response.ok) {
        return response;
      } else {
        commit("setSnackbar", {
          text: "Unexpected error while adding resources",
          enabled: true,
        });
        return response;
      }
    } catch (error) {
      console.error("Error in addProjectResources action:", error);
      throw error;
    }
  },
  async downloadPdf(_, { id, type }) {
    try {
      const response = await api.get("/new-kambuchi/projects/get-pdf-url", {
        id: id,
        type,
      });

      if (!response.ok) {
        throw new Error("Error fetching presigned URL");
      }

      const presignedUrl = response.url;

      const link = document.createElement("a");
      link.href = presignedUrl;
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      return response;
    } catch (error) {
      console.error("Error opening PDF in new tab:", error);
      throw error;
    }
  },
  async fetchActiveProjects() {
    try {
      const response = await api.get("/new-kambuchi/projects/active");
      if (response.ok) {
        return response;
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  },

  async fetchProjectEdit(_, { id_project }) {
    try {
      const response = await api.get(
        "/new-kambuchi/projects/get-project-edit",
        {
          id_project: id_project,
        }
      );
      return response;
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  },

  async editProject({ commit }, data) {
    try {
      const response = await api.put(
        `/new-kambuchi/projects/edit-project`,
        data
      );

      if (response.ok) {
        commit("setSnackbar", {
          text: "Project successfully updated",
          enabled: true,
        });
        return response;
      } else {
        commit("setSnackbar", {
          text: "Unexpected error while editing project",
          enabled: true,
        });
        return response;
      }
    } catch (error) {
      console.error("Error in editProject action:", error);
      throw error;
    }
  },

  async deleteProject({ commit }, data) {
    try {
      const response = await api.put(`/new-kambuchi/projects/delete-project`, data);

      if (response.ok) {
        return response;
      } else {
        commit("setSnackbar", {
          text: "Unexpected error while deleting project",
          enabled: true,
        });
        return response;
      }
    } catch (error) {
      console.error("Error in deleteProject action:", error);
      throw error;
    }
  },

  async copyProject({ commit }, data) {
    try {
      const response = await api.post(`/new-kambuchi/projects/copy-project`, data);

      commit("setSnackbar", {
        text: response.ok
          ? `Empty copy created: ${response.project.name}`
          : response.error || "Unexpected error while copying project",
        enabled: true,
      });
      return response;
    } catch (error) {
      console.error("Error in copyProject action:", error);
      throw error;
    }
  },
};
